// Vue
import { Vue, Component } from "vue-property-decorator";
// Mobx
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
// ViewModel
import { uuid } from "#/common/Utils";
import { ContentModule } from "../../common/content_module/ContentModule";
import { Headline } from "../../../components/headline/Headline";
import { Api } from "../../../api";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ContentModule,
    Headline,
  },
})
export class ModellbeschreibungAnzeigeModule extends ModuleBase {
  private widgetData: object | null = null;

  getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  created() {
    this.loadWidgetData();
  }

  get contentData() {
    if (
      this.widgetData &&
      this.widgetData["content"] &&
      this.widgetData["content"]["content"]
    ) {
      return this.widgetData["content"]["content"];
    } else {
      return null;
    }
  }

  private async loadWidgetData() {
    let token = this.$store.typeSelectionFilter.getToken();
    if (token) {
      let widgetData = await Api.pageService.getModellbeschreibung(
        this.$store.page.page!.id,
        token
      );

      if (widgetData) {
        this.widgetData = widgetData;
      }
    }
  }
}
